import { Grid, TextField } from '@mui/material';
import { Button } from 'components/button';

import {
  Wrapper,
  FormContent,
  IconWrapper,
  Icons,
  ImageWrapper,
  Label,
  Paragraph,
  Title,
} from './styled';

export const Contact = () => {
  return (
    <Wrapper>
      <Grid container spacing={4}>
        <Grid item xl={7.5} lg={6} md={12}>
          <Title>Customer Care</Title>
          <Paragraph>
            Leave us your message. İt might be new offer or report any bug on
            platform.
          </Paragraph>
          <Icons>
            <IconWrapper>
              <img src="./assets/facebook.png" alt="" />
            </IconWrapper>

            <IconWrapper>
              <img src="./assets/linkedin.png" alt="" />
            </IconWrapper>

            <IconWrapper>
              <img src="./assets/twitter.png" alt="" />
            </IconWrapper>
          </Icons>
          <FormContent>
            <Label>Mail</Label>
            <TextField
              placeholder="elonmusk@gmail.com"
              fullWidth
              style={{ background: '#fff' }}
              id="outlined-multiline-flexible"
            />
            <Label>Message</Label>
            <TextField
              style={{ background: '#fff' }}
              placeholder="Talk us about issue"
              variant="outlined"
              fullWidth
              multiline
              minRows={5}
              size="small"
              id="outlined-multiline-flexible"
            />
            <Button
              style={{ mt: '24px', customFloat: 'right', padding: '0 45px' }}
            >
              Send Message
            </Button>
          </FormContent>
        </Grid>
        <Grid item xl={4.5} display={{ md: 'block', xl: 'block', xs: 'none' }}>
          <ImageWrapper>
            <img src="./assets/girl.png" alt="" />
          </ImageWrapper>
        </Grid>
      </Grid>
    </Wrapper>
  );
};
